export interface PaperlessTradeSupport {
  etd: boolean;
  ewo: boolean;
}

export const PAPERLESS_TRADE_COUNTRIES: Record<string, PaperlessTradeSupport> = {
  AD: { etd: false, ewo: true },
  AE: { etd: true, ewo: true },
  AF: { etd: true, ewo: true },
  AG: { etd: false, ewo: true },
  AI: { etd: false, ewo: true },
  AL: { etd: true, ewo: false },
  AM: { etd: false, ewo: true },
  AO: { etd: true, ewo: true },
  AP: { etd: true, ewo: true },
  AR: { etd: false, ewo: true },
  AS: { etd: false, ewo: true },
  AT: { etd: true, ewo: true },
  AU: { etd: true, ewo: true },
  AX: { etd: false, ewo: true },
  AZ: { etd: false, ewo: true },
  BA: { etd: false, ewo: true },
  BB: { etd: true, ewo: false },
  BD: { etd: true, ewo: true },
  BE: { etd: true, ewo: true },
  BF: { etd: false, ewo: true },
  BG: { etd: true, ewo: true },
  BH: { etd: true, ewo: true },
  BI: { etd: false, ewo: true },
  BJ: { etd: false, ewo: true },
  BM: { etd: true, ewo: false },
  BN: { etd: true, ewo: true },
  BO: { etd: true, ewo: true },
  BR: { etd: false, ewo: true },
  BT: { etd: false, ewo: true },
  BV: { etd: false, ewo: true },
  BW: { etd: false, ewo: true },
  BY: { etd: false, ewo: true },
  BZ: { etd: false, ewo: true },
  CA: { etd: true, ewo: true },
  CC: { etd: false, ewo: true },
  CD: { etd: false, ewo: true },
  CG: { etd: false, ewo: true },
  CH: { etd: true, ewo: true },
  CI: { etd: true, ewo: true },
  CK: { etd: true, ewo: true },
  CL: { etd: true, ewo: true },
  CM: { etd: false, ewo: true },
  CN: { etd: true, ewo: true },
  CO: { etd: true, ewo: false },
  CR: { etd: false, ewo: true },
  CV: { etd: false, ewo: true },
  CX: { etd: false, ewo: true },
  CY: { etd: true, ewo: true },
  CZ: { etd: true, ewo: true },
  DE: { etd: true, ewo: true },
  DJ: { etd: false, ewo: true },
  DK: { etd: true, ewo: true },
  DM: { etd: false, ewo: true },
  DO: { etd: true, ewo: true },
  EC: { etd: true, ewo: false },
  EE: { etd: true, ewo: true },
  EG: { etd: false, ewo: true },
  EH: { etd: false, ewo: true },
  EN: { etd: true, ewo: true },
  ER: { etd: false, ewo: true },
  ES: { etd: true, ewo: true },
  ET: { etd: false, ewo: true },
  FI: { etd: true, ewo: true },
  FJ: { etd: true, ewo: false },
  FK: { etd: false, ewo: true },
  FM: { etd: true, ewo: true },
  FO: { etd: false, ewo: true },
  FR: { etd: true, ewo: true },
  GA: { etd: false, ewo: true },
  GB: { etd: true, ewo: true },
  GE: { etd: false, ewo: true },
  GF: { etd: false, ewo: true },
  GH: { etd: false, ewo: true },
  GL: { etd: false, ewo: true },
  GM: { etd: false, ewo: true },
  GN: { etd: false, ewo: true },
  GR: { etd: true, ewo: false },
  GS: { etd: false, ewo: true },
  GT: { etd: false, ewo: true },
  GU: { etd: true, ewo: true },
  GY: { etd: false, ewo: true },
  GZ: { etd: false, ewo: true },
  HK: { etd: true, ewo: true },
  HM: { etd: false, ewo: true },
  HN: { etd: false, ewo: true },
  HO: { etd: true, ewo: true },
  HR: { etd: true, ewo: true },
  HT: { etd: false, ewo: true },
  HU: { etd: true, ewo: true },
  IC: { etd: true, ewo: true },
  ID: { etd: true, ewo: true },
  IE: { etd: true, ewo: true },
  IL: { etd: true, ewo: true },
  IN: { etd: true, ewo: true },
  IO: { etd: false, ewo: true },
  IQ: { etd: false, ewo: true },
  IS: { etd: true, ewo: false },
  IT: { etd: true, ewo: true },
  JM: { etd: true, ewo: true },
  JO: { etd: false, ewo: true },
  JP: { etd: true, ewo: true },
  KE: { etd: false, ewo: true },
  KG: { etd: false, ewo: true },
  KH: { etd: false, ewo: true },
  KN: { etd: false, ewo: true },
  KO: { etd: true, ewo: true },
  KR: { etd: true, ewo: true },
  KV: { etd: false, ewo: true },
  KW: { etd: false, ewo: true },
  KZ: { etd: false, ewo: true },
  LA: { etd: false, ewo: true },
  LB: { etd: false, ewo: true },
  LI: { etd: true, ewo: true },
  LK: { etd: true, ewo: true },
  LR: { etd: false, ewo: true },
  LS: { etd: false, ewo: true },
  LT: { etd: true, ewo: true },
  LU: { etd: true, ewo: true },
  LV: { etd: true, ewo: true },
  M3: { etd: true, ewo: true },
  MA: { etd: false, ewo: true },
  MC: { etd: true, ewo: true },
  MD: { etd: false, ewo: true },
  MG: { etd: false, ewo: true },
  MH: { etd: true, ewo: true },
  MK: { etd: false, ewo: true },
  ML: { etd: false, ewo: true },
  MN: { etd: true, ewo: true },
  MO: { etd: true, ewo: true },
  MP: { etd: true, ewo: true },
  MQ: { etd: false, ewo: true },
  MR: { etd: false, ewo: true },
  MS: { etd: false, ewo: true },
  MT: { etd: true, ewo: true },
  MU: { etd: true, ewo: true },
  MV: { etd: false, ewo: true },
  MW: { etd: false, ewo: true },
  MX: { etd: true, ewo: true },
  MY: { etd: true, ewo: true },
  MZ: { etd: false, ewo: true },
  NA: { etd: false, ewo: true },
  NB: { etd: true, ewo: true },
  NE: { etd: false, ewo: true },
  NF: { etd: false, ewo: true },
  NG: { etd: false, ewo: true },
  NI: { etd: false, ewo: true },
  NL: { etd: true, ewo: true },
  NO: { etd: false, ewo: true },
  NZ: { etd: true, ewo: true },
  OM: { etd: false, ewo: true },
  PA: { etd: false, ewo: true },
  PE: { etd: true, ewo: true },
  PF: { etd: false, ewo: true },
  PG: { etd: false, ewo: true },
  PH: { etd: true, ewo: true },
  PK: { etd: true, ewo: true },
  PL: { etd: true, ewo: true },
  PN: { etd: false, ewo: true },
  PO: { etd: true, ewo: true },
  PR: { etd: true, ewo: true },
  PS: { etd: true, ewo: true },
  PT: { etd: true, ewo: true },
  PW: { etd: true, ewo: true },
  PY: { etd: true, ewo: true },
  QA: { etd: false, ewo: true },
  RO: { etd: true, ewo: true },
  RS: { etd: false, ewo: true },
  RT: { etd: true, ewo: true },
  RW: { etd: false, ewo: true },
  SA: { etd: true, ewo: true },
  SC: { etd: false, ewo: true },
  SE: { etd: true, ewo: true },
  SF: { etd: true, ewo: true },
  SG: { etd: true, ewo: true },
  SI: { etd: true, ewo: true },
  SJ: { etd: false, ewo: true },
  SK: { etd: true, ewo: true },
  SM: { etd: true, ewo: true },
  SN: { etd: false, ewo: true },
  SP: { etd: true, ewo: true },
  SR: { etd: false, ewo: true },
  SW: { etd: false, ewo: true },
  SX: { etd: false, ewo: true },
  TA: { etd: false, ewo: true },
  TC: { etd: false, ewo: true },
  TD: { etd: false, ewo: true },
  TF: { etd: false, ewo: true },
  TG: { etd: true, ewo: true },
  TH: { etd: true, ewo: true },
  TI: { etd: true, ewo: true },
  TL: { etd: true, ewo: true },
  TN: { etd: true, ewo: true },
  TO: { etd: false, ewo: true },
  TP: { etd: true, ewo: false },
  TR: { etd: true, ewo: true },
  TT: { etd: false, ewo: true },
  TU: { etd: true, ewo: true },
  TW: { etd: true, ewo: true },
  TZ: { etd: false, ewo: true },
  UG: { etd: false, ewo: true },
  UI: { etd: false, ewo: true },
  UM: { etd: false, ewo: true },
  US: { etd: true, ewo: true },
  UV: { etd: false, ewo: true },
  UY: { etd: true, ewo: true },
  UZ: { etd: false, ewo: true },
  VA: { etd: true, ewo: true },
  VC: { etd: false, ewo: true },
  VG: { etd: false, ewo: true },
  VI: { etd: false, ewo: true },
  VL: { etd: false, ewo: true },
  VN: { etd: true, ewo: true },
  VR: { etd: false, ewo: true },
  VU: { etd: true, ewo: true },
  WF: { etd: false, ewo: true },
  WL: { etd: true, ewo: true },
  WS: { etd: false, ewo: true },
  YA: { etd: true, ewo: true },
  ZA: { etd: true, ewo: false },
  ZM: { etd: false, ewo: true },
};
